import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    success: (memberName: string, resourceName: string) => string | React.ReactNode;
    error: (resourceName: string, errorMessage?: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Success toast message when member is removed from resource */
            success: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (memberName: string, resourceName: string) => __intl__.intl().formatMessage({ id: "useDeleteMembership.success?c=1yc0izuqqkbo3", defaultMessage: "{memberName} removed from {resourceName}" }, { memberName: memberName, resourceName: resourceName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error toast message when member removal fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (resourceName: string, errorMessage?: string) => __intl__.intl().formatMessage({ id: "useDeleteMembership.error?c=3ezycktoyvjg7", defaultMessage: "Unable to remove from {resourceName}{errorMessage, select, true {: {errorMessage}} other {}}" }, { resourceName: resourceName, errorMessage: errorMessage }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
